const formatCurrency = (amount: string) => {
  return parseInt(amount).toLocaleString("en-EN", {
    style: "currency",
    currency: "USD",
  })
}

export default formatCurrency
